var constants = require('../constants');
var metaConstants = require('../../meta/constants');
var api = require('../../../utils/api');
var profileUtils = require('../profileUtils');
var commonActions = require('../../common/actions/common');
var collectZipCodeMetaActions = require('../../meta/actions/collect-zip-code');
var postalCodeUtils = require('../../profile/postalCodeUtils');

var profileActions = (function(){

    var _updateProfileRequest = function() {
        return {
            type: constants.PROFILE_UPDATE_REQUEST
        };
    }

    var _updateProfileSuccess = function(data, recordEvent) {
        var action = {
            type: constants.PROFILE_UPDATE_SUCCESS,
            data: data || {}
        };

        if(recordEvent !== false){
            action.meta = {
                analytics: {
                    eventType: constants.PROFILE_UPDATE_SUCCESS,
                    actionValue: 'response',
                    labelValue: 'success'
                }
            }
        }

        return action;
    }

    var _updateProfileFailure = function(error) {
        return {
            type: constants.PROFILE_UPDATE_FAILURE,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.PROFILE_UPDATE_FAILURE,
                    actionValue: 'response',
                    labelValue: 'failure'
                }
            }
        };
    }

    var _validationProfileError = function(error) {
        return {
            type: constants.VALIDATION_PROFILE_ERROR,
            errors: error
        };
    }

    var _clearProfileError = function() {
        return {
            type: constants.CLEAR_PROFILE_ERROR
        };
    }

    var _setProfileSuccess = function(){
        return {
            type: constants.SET_PROFILE_SUCCESS,
            success: 'Profile updated successfully'
        };
    }

    var _clearProfileSuccess = function(){
        return {
            type: constants.CLEAR_PROFILE_SUCCESS
        };
    }

    var _updateProfile = function(firstName, lastName, gender, dob, postalCode, token) {
        return function(dispatch) {
            profileUtils.validate(firstName, lastName, gender, dob, postalCode)
                .then(function(result) {
                    if (result === true) {

                        dispatch(_updateProfileRequest());

                        api.put('/proxy/v1/profiles', {
                                "firstName": firstName,
                                "lastName": lastName,
                                "sex": gender,
                                "dateOfBirth": dob,
                                "postalCode": postalCode
                            }, token)
                            .then(function(data) {
                                dispatch(_setProfileSuccess());
                                dispatch(_updateProfileSuccess(data.profile));
                            })
                            .catch(function(error) {
                                if(error.response){
                                    dispatch(_updateProfileFailure(error.response));
                                }else{
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            })
                    } else {
                        dispatch(_validationProfileError(result));
                    }
                })
        };
    }

    var _setPostalCodeError = function(error){
        return {
            type: constants.SET_POSTAL_CODE_ERROR,
            errors: error
        };
    };

    var _clearPostalCodeError = function(){
        return {
            type: constants.CLEAR_POSTAL_CODE_ERROR
        };
    };

    var _saveProfilePostalCodeSuccess = function(data){
        return {
            type: constants.SAVE_PROFILE_POSTAL_CODE_SUCCESS,
            data: data
        };
    };

    var _isSavingProfilePostalCode = false;
    var _saveProfilePostalCode = function(postalCode, token){
        return function(dispatch) {
            postalCodeUtils.validate(postalCode)
                .then(function(result) {
                    if (result === true) {
                        if(_isSavingProfilePostalCode) return;

                        dispatch(collectZipCodeMetaActions.recordCollectZipCodeMeta('submit', 'success'));

                        _isSavingProfilePostalCode = true;
                        api.patch('/proxy/v1/profiles', {
                                postalCode: postalCode
                            }, token)
                            .then(function(data) {
                                _isSavingProfilePostalCode = false;

                                dispatch(_saveProfilePostalCodeSuccess(data.profile));
                                dispatch(collectZipCodeMetaActions.recordCollectZipCodeMeta('response', 'success'));
                            })
                            .catch(function(error) {
                                _isSavingProfilePostalCode = false;

                                // dispatch(_setPostalCodeError(error.response ? (error.response.data.message || error.response.data) : error.message));
                                if(error.response){
                                    dispatch(commonActions.setGenericResponseError('', error.response));
                                    dispatch(collectZipCodeMetaActions.recordCollectZipCodeMeta('response', 'failure'));
                                }else{
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            });
                    } else {
                        dispatch(_setPostalCodeError(result));
                    }
                });
        };
    };

    var _interestedInClinicalTrialsSuccess = function(data){
        return {
            type: constants.INTERESTED_IN_CLINICAL_TRIALS_SUCCESS,
            data: data,
            meta: {
                analytics: {
                    eventType: metaConstants.CLINICAL_TRIALS_SUCCESS,
                    actionValue: 'response',
                    labelValue: 'success'
                }
            }
        };
    };

    var _isInterestedInClinicalTrials = false;
    var _interestedInClinicalTrials = function(postalCode, token){
        return function(dispatch) {
            if(_isInterestedInClinicalTrials) return;

            var patchData = {
                contactForTrials: true
            };

            if(postalCode){
                patchData.postalCode = postalCode;
            }

            _isInterestedInClinicalTrials = true;
            api.patch('/proxy/v1/profiles', patchData, token)
                .then(function(data) {
                    _isInterestedInClinicalTrials = false;

                    dispatch(_interestedInClinicalTrialsSuccess(data.profile));
                })
                .catch(function(error) {
                    _isInterestedInClinicalTrials = false;

                    if(error.response){
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                })
        };
    };

    var _revertIsPending = function (token) {
        return function (dispatch) {
            var patchData = {
                isPending: false,
            }

            dispatch(_updateProfileRequest());
            api.patch('/proxy/v1/profiles', patchData, token).then(function (data) {
                dispatch(_updateProfileSuccess(data.profile));
            })
                .catch(function (error) {
                    if (error.response) {
                        dispatch(_updateProfileFailure(error.response));
                    } else {
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                })
        }
    }

    return {
        updateProfile: _updateProfile,
        updateProfileSuccess: _updateProfileSuccess,
        clearProfileError: _clearProfileError,
        clearProfileSuccess: _clearProfileSuccess,
        interestedInClinicalTrials: _interestedInClinicalTrials,
        saveProfilePostalCode: _saveProfilePostalCode,
        setPostalCodeError: _setPostalCodeError,
        clearPostalCodeError: _clearPostalCodeError,
        revertIsPending: _revertIsPending,
    }
})();

module.exports = profileActions;



// WEBPACK FOOTER //
// ./src/common/modules/profile/actions/profile.js